export default __webpack_public_path__ + "static/media/purefi-logo.29be9cd6.svg";